export const environment = {
    production: true,

    ApiBase: "./CustomerPortal.API/",

    ImageLocation: "assets/",
    LocalImageLocation: "assets/",
    PageIcon: "assets/icons/favicon-usnr.png",

    DocumentLocation: "assets/documents/",

    System: "USNR"
};
